<div
  class="selected flex h-11 w-11 cursor-pointer select-none items-center justify-center
    rounded-md"
  (click)="toggleNotificationMenu($event)">
  @if (unreadCountBadge() !== 0) {
    <p-overlaybadge [value]="unreadCountBadge()" badgeSize="small" class="h-5">
      <ng-icon name="phosphorBell" class="text-xl !text-surface-500" />
    </p-overlaybadge>
  } @else {
    <ng-icon name="phosphorBell" class="text-xl !text-surface-500" />
  }
</div>
<notifications-list />
